
import  {client_product}  from '../client';
import {
  GET_SHOPS,
  GET_VENDORS
} from '../vendorGQL';
import { ApolloClient, DocumentNode } from '@apollo/client';

const env = process.env.REACT_APP_ENV_SETTINGS || 'dev';

export const safeGraphQLQuery = async <T>(
  client: ApolloClient<any>,
  query: DocumentNode,
  variables?: Record<string, any>
): Promise<T> => {
  const response = await client.query({
    query,
    variables,
    fetchPolicy: 'network-only', // 👈 force bypass cache
  });

  if (response.errors?.length) {
    throw new Error(response.errors[0].message || 'Unknown GraphQL error');
  }

  if (!response.data) {
    throw new Error('No data returned from GraphQL');
  }

  return response.data as T;
};

export const fetchVendors = async () => {
  try {
   

    if (env === 'dev') {
      const res = await fetch(`http://localhost:5000/getVendorByUserId`);
      if (!res.ok) throw new Error('Failed to fetch vendor (REST)');
      const data = await res.json();
      if (!data || typeof data !== 'object') throw new Error('Invalid vendor response');
      return data;
    } else {
      

      const data = await safeGraphQLQuery<{ vendors: any }>(
        client_product,
        GET_VENDORS
      );

      if (!data.vendors) {
        throw new Error('Vendors not found');
      }

      return data.vendors;
    }
  } catch (error) {
    console.error('Error in vendors:', error);
    throw error;
  }
};


export const fetchShops = async () => {
  try {
   

    if (env === 'dev') {
      const res = await fetch(`http://localhost:5000/Shops`);
      if (!res.ok) throw new Error('Failed to fetch shops (REST)');
      const data = await res.json();
      if (!data || typeof data !== 'object') throw new Error('Invalid shops response');
      return data;
    } else {
      
      const data = await safeGraphQLQuery<{ shops: any }>(
        client_product,
        GET_SHOPS
      );

      if (!data.shops) {
        throw new Error('Shops not found');
      }

      return data.shops;
    }
  } catch (error) {
    console.error('Error in shops:', error);
    throw error;
  }
};